// extracted by mini-css-extract-plugin
module.exports = {"root":"_2-v2G","bg":"_1dvDx","left":"_3ijyb","right":"BjBAC"};